import React, { FunctionComponent } from "react";
import InfyButton from "../../InfyButton/InfyButton";
import styles from "./TabularForm.module.scss";

interface FooterProps {
  onCancel: () => void;
  onSaveDraft: () => void;
  onSave: () => void;
  draftLoading?: boolean;
  saveLoading?: boolean;
  disabled?: boolean;
}

// Sticky action bar pinned to the bottom of the grid.
const Footer: FunctionComponent<FooterProps> = ({ onCancel, onSaveDraft, onSave, draftLoading, saveLoading, disabled }) => (
  <div className={styles.footer}>
    <InfyButton type="ghost" bicolor="primary" onClick={onCancel} disabled={disabled}>
      Cancel
    </InfyButton>
    <InfyButton type="ghost" bicolor="primary" loading={draftLoading} onClick={onSaveDraft} disabled={disabled}>
      Save as Draft
    </InfyButton>
    <InfyButton type="primary" bicolor="primary" loading={saveLoading} onClick={onSave} disabled={disabled}>
      Save
    </InfyButton>
  </div>
);

export default Footer;
